var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXinshexiangtou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 62",
    cx: 8.00016,
    cy: 6.66667,
    r: 6.16667,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 63",
    cx: 8,
    cy: 6.66663,
    r: 4,
    fill: "#1FDDFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 64",
    cx: 5.33333,
    cy: 5.33333,
    r: 1.33333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631276",
    x: 7,
    y: 13,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631277",
    x: 1,
    y: 15,
    width: 14,
    height: 1,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXinshexiangtou);
export default __webpack_public_path__ + "static/media/xinshexiangtou.a889bce9a7fe539f9fb6b5ced705c2e5.svg";
export { ForwardRef as ReactComponent };